import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form";
import { Typography, Box, Button } from "@mui/material";
import {
    getOwners,
    getOwner,
    getInspectors,
    getOrganizations,
    getUsersData,
} from "../../api";
import Spinner from "../../components/Spinner";
import { useSnackbar } from "../../utils/index.js";
import OwnerForm from "../../components/forms/OwnerForm.js";
import useSelectStyles from "../../components/styles/Select.js";

const SelectOwner = () => {
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [ownerId, setOwnerId] = useState();
    const [fetchedOwner, setFetchedOwner] = useState();
    const [fetchedInspectors, setFetchedInspectors] = useState([]);
    const [fetchedOrganizations, setFetchedOrganizations] = useState([]);
    const [fetchedUsers, setFetchedUsers] = useState([]);
    const [isOwnerSelected, setIsOwnerSelected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const classes = useSelectStyles();
    const { error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners);
                const ownersDropdownArr = []
                for (var owner of owners) {
                    ownersDropdownArr.push({ value: `${owner.code} - ${owner.lastName} ${owner.firstName}`, text: `${owner.code} - ${owner.lastName} ${owner.firstName}` });
                }
                setOwnersDropdownValues(ownersDropdownArr);

                const { inspectors } = await getInspectors();
                setFetchedInspectors(inspectors);

                const { organizations } = await getOrganizations();
                setFetchedOrganizations(organizations);

                const { users } = await getUsersData();
                setFetchedUsers(users);
            } catch (err) {
                error(err)
            }
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const selectFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const handleOwnerSelectSubmit = async (values) => {
        setIsLoading(true);
        const selectedOwnerId = fetchedOwners.find((owner) => `${owner.code} - ${owner.lastName} ${owner.firstName}` === values.owner)._id;

        const { success: successCode, owner, message } = await getOwner(selectedOwnerId);
        
        if (successCode) {
            const ownersInspector = fetchedInspectors.find((inspector) => inspector._id === owner?.inspector);
            ownersInspector ? owner.inspector = `${ownersInspector.lastName} ${ownersInspector.firstName}` : owner.inspector = null;

            if (owner?.organization) {
                const ownersOrganization = fetchedOrganizations.find((organization) => organization._id === owner?.organization);
                ownersOrganization ? owner.organization = ownersOrganization.name : owner.organization = null;
            }

            if (owner?.user) {
                const ownersUser = fetchedUsers.find((user) => user._id === owner?.user);
                ownersUser ? owner.user = ownersUser.username : owner.user = null;
            }
            setOwnerId(owner._id);
            setFetchedOwner(owner);
            setIsOwnerSelected(true);
        } else {
            error(message)
        }

        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    {!isOwnerSelected && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επιλέξτε την εκτροφή που σας ενδιαφέρει:
                            </Typography>
                            <Form content={selectFormContent} onSubmit={handleOwnerSelectSubmit} />
                        </>
                    )}
                    {isOwnerSelected && (
                        <>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επεξεργασία εκτροφής
                            </Typography>
                            <OwnerForm
                                isCreate={false}
                                fetchedOwner={fetchedOwner}
                                setFetchedOwner={setFetchedOwner}
                                ownerId={ownerId}
                                setIsOwnerSelected={setIsOwnerSelected}
                            />
                            <Button
                                onClick={() => setIsOwnerSelected(false)}
                                sx={{
                                    marginTop: "1rem",
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "third",
                                    color: "secondary.main",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    variant: "h5",
                                }}
                            >
                                Πίσω
                            </Button>
                        </>
                    )}

                </Box>
            </Box>
        </>
    )
}


export default memo(SelectOwner)